import React, { useState, useEffect, useCallback } from 'react';
import ClientContactsTable from '../components/ClientContactsTable';
import { clientStore } from '../ClientStore';
import EmptyState from 'ats/components/empty-state/EmptyState';
import { EMPTY_STATE_ICONS } from 'ats/components/empty-state/emptyStateIcons';
import { modalStore } from 'components/layout/modals/ModalStore';
import { ClientContactCreate } from '../components/ClientContactCreate';

export default function ClientContacts({ client, onSuccess }) {
	const [clientContacts, setClientContacts] = useState([]);

	const loadClientContacts = useCallback(async () => {
		if (!client?.id) return;

		try {
			const result = await clientStore.getClientContacts(client.id);
			if (result.status === 'success') {
				setClientContacts(result.data.rows || result.data || []);
			}
		} catch (error) {
			console.error('Error loading client contacts:', error);
		}
	}, [client]);

	useEffect(() => {
		loadClientContacts();
	}, [loadClientContacts]);

	const handleSuccess = () => {
		loadClientContacts();
		if (onSuccess) {
			onSuccess();
		}
	};

	const handleCreateContact = () => {
		modalStore.openModal(
			{
				title: `New client contact for ${client?.name}`,
				size: 'md',
				position: 'center',
				saveButtonLabel: 'Create'
			},
			<ClientContactCreate
				clientId={client?.id}
				handleSuccess={handleSuccess}
			/>
		);
	};

	const hasContacts = clientContacts.length > 0;

	return (
		<div className="client-contacts">
			<div className="client-tab-section-header">
				<div className="client-tab-section-title">Client Contacts</div>
				<div className="table-action-buttons">
					<button
						type="button"
						className="ats-button-soft"
						onClick={handleCreateContact}>
						Add Contact
					</button>
				</div>
			</div>
			<div className="client-contacts-body">
				{hasContacts ? (
					<div className="client-contacts-container">
						<ClientContactsTable
							data={clientContacts}
							clientId={client?.id}
							onSuccess={handleSuccess}
						/>
					</div>
				) : (
					<EmptyState
						icon={EMPTY_STATE_ICONS.candidate}
						iconAlt="No contacts"
						message="No contacts linked to this client."
						actionText="Add Client Contact"
						onActionClick={handleCreateContact}
					/>
				)}
			</div>
		</div>
	);
}
